// extracted by mini-css-extract-plugin
module.exports = {"page":"page-module--page--2NQtN"};